<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <div :class="cn('rounded-lg border border-slate-200 bg-white text-slate-950 shadow-xs', props.class)">
    <slot />
  </div>
</template>
